module.exports = __webpack_public_path__ + "static/qq_qrcode-a97b374402af0650d0c307658f913076.png";